import {IntegrationsPageLayout} from '../../../_gori/layout/components/IntegrationsPagesLayout'
import {SeoHead} from '../../modules/seo'

export function TikTokIntegration() {
  return (
    <>
      <SeoHead />
      <IntegrationsPageLayout
        pageClass='tiktok-integration'
        integrationLogo='/media/gori/integrations/tiktok/tiktok-logo.svg'
        integrationLogoAlt='tiktok-logo'
        integrateImg='/media/gori/integrations/tiktok/integrate.webp'
        card1Copy='TIKTOK_CARD_1'
        card2Copy='TIKTOK_CARD_2'
        card3Copy='TIKTOK_CARD_3'
        card4Copy='TIKTOK_CARD_4'
        store='TikTok'
      />
    </>
  )
}
